import React from "react";
import "./OrganizationalChart.scss";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useIntl } from "react-intl";
import HtmlView from "component/htmlView/html-view";
import { API_BASE_URL } from "configs/AppConfig";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { useSelector } from "react-redux";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
// import { TRANSLATION_KEYS } from "constants/TranslationConstant";
import { END_POINTS } from "constants/APIConstant";
import useSWR from "swr";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import ReactGA from "react-ga4";

function OrganizationalChart() {
  const intl = useIntl();

  const currentLocale = useSelector(({ theme }) => theme.locale);


  ReactGA.initialize(END_POINTS.TRACKING_ID);
  
  React.useEffect(() => {
      // Send pageview with a custom path
      ReactGA.send({ hitType: "pageview", page: "/about/organizaitional-structure", title: "About organizaitional-structure Page" });
  }, []);


  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  React.useEffect(() => {
    setExpanded(`panel1`);
  }, []);

  const sectorsImg = useSWR({
    url: END_POINTS.IMAGE_ORGANIZATIONAL_CHART,
  });

  const sectorsList = useSWR({
    url: END_POINTS.SECTORS,
  });

  return (
    <ContentLoading isLoading={sectorsImg.isLoading || sectorsList.isLoading}>
      <div className="OrganizationalChart">
        <div className="img-org">
          <img
            src={
              sectorsImg?.data?.data?.value !== null && sectorsImg?.data?.data?.value !== undefined
                ? `${API_BASE_URL}/${LabelLangString({
                    id: "value",
                    currentLocale: currentLocale,
                    defaultValue: sectorsImg?.data?.data?.value,
                    translations: sectorsImg?.data?.data?.elementTranslations,
                  })}`
                : process.env.PUBLIC_URL + "/image/OrganizationalChart.png"
            }
            alt="organizational-stracture"
            loading="lazy"
          />
        </div>
        <div className="m__title">
          <h3>{intl.formatMessage({ id: "sectors-departments" })}</h3>
        </div>

        <div className="OrganizationalChart-coll">
          {sectorsList?.data?.data && Object.keys(sectorsList?.data?.data).length > 0 ? (
            sectorsList?.data?.data.map(
              ({ id, title, description, sectorTranslations }, i) => (
                <Accordion
                  key={i}
                  className="mb-2"
                  expanded={expanded === `panel${id}`}
                  onChange={handleChange(`panel${id}`)}
                >
                  <AccordionSummary
                    aria-controls={`panel${id}bh-content`}
                    id={`panel${id}bh-header`}
                    className={"coll-item-headr"}
                  >
                    <div
                      className={`icon ${
                        expanded === `panel${id}` ? "open" : "close"
                      }`}
                    >
                      <i className="fas fa-minus"></i>
                      <i className="fas fa-plus"></i>
                    </div>
                    <h6>
                      {LabelLangString({
                        id: "title",
                        currentLocale: currentLocale,
                        defaultValue: title,
                        translations: sectorTranslations,
                      })}
                    </h6>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ textAlign: "start", paddingLeft: "3rem" }}
                    className="coll-dateils"
                  >
                    <div className="row gy-3 mt-2 justify-content-center align-items-center">
                      <div className="col-12 col-lg-8">
                        {description ? (
                          <HtmlView
                            html={LabelLangString({
                              id: "description",
                              currentLocale: currentLocale,
                              defaultValue: description,
                              translations: sectorTranslations,
                            })}
                          />
                        ) : (
                          <DataNotFound />
                        )}
                      </div>
                      <div className="col-12 col-lg-4">
                        {/* <div className="box-info mb-4">
                        <div className="box-info-header">
                          <p>المسئول عن هذه الخدمة</p>
                          <p> الإدارة العامة للشئون الفنية</p>
                        </div>
                        <ul>
                          <li>
                            <img 
                              src={process.env.PUBLIC_URL + "/image/info1.svg"}
                              alt="phone"
                              loading="lazy"
                            />

                            <span>+202.2402.4099</span>
                          </li>
                          <li>
                            <img 
                              src={process.env.PUBLIC_URL + "/image/info2.svg"}
                              alt="mail"
                              loading="lazy"
                            />

                            <span>informationbank@capmas.gov.eg</span>
                          </li>
                          <li>
                            <img 
                              src={process.env.PUBLIC_URL + "/image/info3.svg"}
                              alt="location"
                              loading="lazy"
                            />

                            <span>
                              المقر الرئيسي: طريق صلاح سالم، مدينة نصر، القاهرة
                            </span>
                          </li>
                        </ul>
                      </div> */}
                        <div>
                          <img
                            className="img-fluid"
                            src={process.env.PUBLIC_URL + "/image/pr.svg"}
                            alt="back-ground"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="row mt-5">
                      <div className="col-12 col-lg-8">
                        <div className="calnd-info">
                          <h6>الإدارات المركزية التابعة</h6>
                          <ul className="listt">
                            <li>الإدارة المركزية للحاسب الآل</li>
                            <li>الإدارة المركزية لنظم المعلومات</li>
                            <li>الإدارة المركزية للدعم الفني والتطوير</li>
                            <li>
                              الإدارة المركزية للتدريب على تكنولوجيا المعلومات{" "}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-12 col-lg-4">
                        <div className="">
                          <img 
                            className="img-fluid"
                            src={process.env.PUBLIC_URL + "/image/pr.svg"}
                            alt="back-ground"
                            loading="lazy"
                          />
                        </div>
                        <ul>
                          <li>
                            <img 
                              src={process.env.PUBLIC_URL + "/image/info1.svg"}
                              alt="phone"
                              loading="lazy"
                            />
    
                            <span>+202.2402.4099</span>
                          </li>
                          <li>
                            <img 
                              src={process.env.PUBLIC_URL + "/image/info2.svg"}
                              alt="mail"
                              loading="lazy"
                            />
    
                            <span>informationbank@capmas.gov.eg</span>
                          </li>
                          <li>
                            <img 
                              src={process.env.PUBLIC_URL + "/image/info3.svg"}
                              alt="location"
                              loading="lazy"
                            />
    
                            <span>
                              المقر الرئيسي: طريق صلاح سالم، مدينة نصر، القاهرة
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </AccordionDetails>
                </Accordion>
              )
            )
          ) : (
            <DataNotFound />
          )}
        </div>
      </div>
    </ContentLoading>
  );
}

export default OrganizationalChart;
